<div class="w-100 h-100">
 
    <div class="d-flex justify-content-center">
        <div class="box pb-3">
            <div class="card-box bg-blue" :class="{'active': requestStatusBox.includes('0') || requestStatusBox.length === 0 }" @click="filter('0', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.all')}}<br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.all}}</h2>
                    </div>
                </div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-gray" :class="{'active': requestStatusBox.includes('7') && !requestStatusBox.includes('0')}" @click="filter('7', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.pendingFor')}}<br /> {{$t('dashboardPage.payment')}} </label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.pendingForPayment}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.pendingForPaymentPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-pink" :class="{'active': requestStatusBox.includes('1') && !requestStatusBox.includes('0')}" @click="filter('1', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.pendingFor')}} <br /> {{$t('dashboardPage.approval')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.pendingForApproval}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.pendingForApprovalPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-red" :class="{'active': requestStatusBox.includes('3') && !requestStatusBox.includes('0')}" @click="filter('3', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.rejected')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.rejected}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.rejectedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-green" :class="{'active': requestStatusBox.includes('8') && !requestStatusBox.includes('0')}" @click="filter('8', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">
                            {{$t('bulkshortPage.completed')}}<br /> {{$t('dashboardPage.requests')}}
                        </label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.approvedAndPaid}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.approvedAndPaidPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-dark-blue" :class="{'active': requestStatusBox.includes('5') && !requestStatusBox.includes('0')}" @click="filter('5', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('dashboardPage.expired')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.expired}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.expiredPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-parpol" :class="{'active': requestStatusBox.includes('11') && !requestStatusBox.includes('0')}" @click="filter('11', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('shared.deactivated')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.deactivated}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.deactivatedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>

        <div class="box pb-3">
            <div class="card-box bg-orange" :class="{'active': requestStatusBox.includes('6') && !requestStatusBox.includes('0')}" @click="filter('6', '0')">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('shared.deleted')}} <br /> {{$t('dashboardPage.requests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{dashboardBoxes.deleted}}</h2>
                    </div>
                </div>
                <div class="card-box-footer">{{dashboardBoxes.deletedPercentage}}% {{$t('dashboardPage.thisMonth')}}</div>
            </div>
        </div>
    </div>
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="reload()"></i>
                                {{$t('dashboardPage.requests')}} ({{sendersCount}})
                            </label>
                        </div>
                        <div class="col-auto">
                            <button v-if="userRole == 2 || userRole == 5" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showresendDialog('')">{{$t('dashboardPage.resend')}}</button>
                            <button v-if="userRole == 2 || userRole == 5" class="btn btn-primary btn-action" @click="exportToExcel()">{{$t('shared.exportToExcel')}}</button>
                            <button v-if="canRenewTemplates" :disabled="!isSelectionRenewable" class="btn btn-primary btn-action" @click="openTemplateRenewal('')">{{$t('dashboardPage.renew')}}</button>
                            <router-link v-if="((userRole == 2 || userRole == 5) && !providerLocked &&  !providerExpired)" to="/MessageTemplateReqeust" tag="button" class="btn btn-primary btn-action">{{$t('dashboardPage.newRequest')}} <i class="fas fa-plus px-2"></i></router-link>

                            <button v-if="userRole == 1 || userRole == 9|| userRole == 15" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showapproveDialog('')">{{$t('dashboardPage.Approve')}}</button>
                            <button v-if="userRole == 1 || userRole == 9|| userRole == 15" :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showRejectDialog('')">{{$t('dashboardPage.reject')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row align-items-start w-100">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.displayId"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.displayId')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.templateName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.templateName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.senderName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.senderNameSearch')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               @input="onInputSearch"
                                               v-model="filterModel.clientName"
                                               :placeholder="$t('dashboardPage.clientName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-3">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table v-model="selected"
                                      :headers="visibleHeaders"
                                      :items="senders"
                                      :total-items="sendersCount"
                                      select-all
                                       :pagination="pagination"
                                      @update:pagination="updatePaginate"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      item-key="requestId"
                                      class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th>
                                        <v-checkbox :input-value="props.all"
                                                    :indeterminate="props.indeterminate"
                                                    primary
                                                    hide-details
                                                    @click.stop="selectAll"></v-checkbox>
                                    </th>
                                    <th v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                        @click="changeSort(header.value)" :width="header.width !== ''? header.width : ''">
                                        <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-checkbox v-model="props.selected"
                                                    @change="select($event, props.item.id)"
                                                    primary
                                                    hide-details></v-checkbox>
                                    </td>
                                     <td class="text-center">{{ props.item.displayId }}</td>
                                     <td class="text-center" style="text-align: center;">
                                         {{props.item.templateName}}
                                         <span v-if="isRenewalRequest(props.item)" class="badge badge-info ml-1">{{$t('dashboardPage.renewalBadge')}}</span>
                                     </td>
                                     <td class="text-center">{{props.item.senderName}}</td>
                                     <td class="text-center">{{props.item.classification}}</td>
                                     <td class="text-center">{{ props.item.templateStatus }}</td>

                                     <td class="text-center">{{ props.item.clientName }}</td>
                                     <td class="text-center">{{ props.item.createdDate }}</td>
                                     <td class="text-center" v-if="!isTemplateExpiryDateHidden">{{ props.item.expiryDate }}</td>
                                     <td class="text-center">
                                         <div class="d-flex justify-content-center align-items-center">
                                             <div class="status_txt" :class="'status-' + props.item.requestStatus +'-template'" :style="{ color: checkColor(props.item.requestStatus) }">{{GetTemplateStatus(props.item.requestStatus)}}</div>
                                             <Progress v-if="!isTemplateDaysLeftHidden" :transitionDuration="1000" :radius="10" :strokeColor="checkColor(props.item.requestStatus)" :strokeWidth="5" :value="getRate(props.item.remainingDays,props.item.totalDays)">
                                                 <div class="content"></div>
                                                 <template v-slot:footer>
                                                     <b></b>
                                                 </template>
                                             </Progress>
                                             <div class="days_left" v-if="!isTemplateDaysLeftHidden">
                                                 {{props.item.remainingDays}} {{$t('dashboardPage.of')}} {{props.item.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                             </div>
                                         </div>
                                     </td>


                                    <td class="text-center btn_menu">
                                        <template>
                                            <v-menu offset-y open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="btn-primary"
                                                           v-on="on">
                                                        <div>{{$t('shared.actions')}}</div>
                                                        <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <template v-if="userRole == 2 || userRole == 5">
                                                        <v-list-tile v-if="(props.item.requestStatus == '7' || props.item.requestStatus == '3') && !isRenewalRequest(props.item)" :to="'/MessageTemplateDashboard/UpdateMessageTemplateRequest/' + props.item.id">
                                                            <v-list-tile-title class="white">{{$t('shared.edit')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="props.item.requestStatus == '7' && messageTemplatePaymentPhaseEnabled" @click="PreparePay(props.item.id)">
                                                             <v-list-tile-title class="white">{{$t('dashboardPage.Pay')}}</v-list-tile-title>
                                                         </v-list-tile>

                                                        <v-list-tile v-if="props.item.requestStatus == '3' && !isRenewalRequest(props.item)" @click="showresendDialog(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.resend')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="canRenewTemplates && isRenewalEligibleRow(props.item)" @click="openTemplateRenewal(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.renew')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                    </template>

                                                    <template v-if="userRole == 1 || userRole == 9 || userRole == 15">
                                                        <v-list-tile v-if="props.item.requestStatus == '8'" :to="'/MessageTemplateDashboard/UpdateMessageTemplateRequest/' + props.item.id">
                                                            <v-list-tile-title class="white">{{$t('shared.edit')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="props.item.requestStatus == '1'" @click="showapproveDialog(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.Approve')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="props.item.requestStatus == '1'" @click="showRejectDialog(props.item.id)">
                                                            <v-list-tile-title class="white">{{$t('dashboardPage.reject')}}</v-list-tile-title>
                                                        </v-list-tile>
                                                        <v-list-tile v-if="props.item.requestStatus == '8' || props.item.requestStatus == '11'" @click="showDeleteDialog(props.item.id)">
                                                             <v-list-tile-title class="white">{{$t('shared.delete')}}</v-list-tile-title>
                                                         </v-list-tile>
                                                         <v-list-tile v-if="props.item.requestStatus == '8' || props.item.requestStatus == '5'" @click="showDeactivateDialog(props.item.id)">
                                                             <v-list-tile-title class="white">{{$t('dashboardPage.deactivate')}}</v-list-tile-title>
                                                         </v-list-tile>
                                                    </template>

                                                    <v-list-tile @click="Details(props.item.id)">
                                                        <v-list-tile-title class="white">{{$t('dashboardPage.details')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="resendDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.resendInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideresendDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="resendComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.resendMessageTemplateInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideresendDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="resend('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.approveMessageInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideapproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="deleteDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.delete')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeleteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">{{$t('shared.deleteMessageTemplateInputText')}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeleteDialog">{{$t('shared.cancel')}}</a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deleteRequest('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="deactivateDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.deactivate')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeactivateDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">{{$t('shared.deactivateMessageTemplateInputText')}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeactivateDialog">{{$t('shared.cancel')}}</a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deactivate">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="rejectdialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>

                    <div class="row mt-3">
                        <div class="col-md-12">
                            <reject-reason-multi-select
                                :items="popUpRejectionReasons"
                                :value="selectedRejectReasons"
                                :other-text="otherRejectReasonText"
                                @input="onRejectReasonsChanged"
                                @other-text="onOtherRejectTextChanged">
                            </reject-reason-multi-select>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideRejectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</div>

